import type { ResultOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query searchBrokerages($input: String!, $supportedProviders: [String!]!) {
  searchBrokerages(
    searchInput: { name: $input, supportedProviders: $supportedProviders }
  ) {
    id
    slug
    name
    url
    logoUrl
    countryISO
    provider {
      name
    }
    providerBrokerageId
  }
}
`
);

export type Brokerage = ResultOf<typeof QUERY>['searchBrokerages'][number];

export const useSearchBrokerages = makeGqlQuery(QUERY);
